import avatarModule from '../avatarModule';

function avatarEditorTabs(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarEditorTabs
  };
}

avatarModule.directive('avatarEditorTabs', avatarEditorTabs);

export default avatarEditorTabs;
